const transferFrequency = Object.freeze({
  oneTime: 'ONE_TIME',
  weekly: 'WEEKLY',
  monthly: 'MONTHLY',
  quarterly: 'QUARTERLY',
  annually: 'ANNUALLY',
  everySixMonths: 'RECURRING_6_MONTHS',
  firstFridayOfMonth: 'RECURRING_MONTHLY_FIRST_FRIDAY',
  secondFridayOfMonth: 'RECURRING_MONTHLY_SECOND_FRIDAY',
  thirdFridayOfMonth: 'RECURRING_MONTHLY_THIRD_FRIDAY',
  fourthFridayOfMonth: 'RECURRING_MONTHLY_FOURTH_FRIDAY',
  firstBusinessDayOfMonth: 'RECURRING_MONTHLY_FIRST_BUSINESS_DAY',
  lastBusinessDayOfMonth: 'RECURRING_MONTHLY_LAST_BUSINESS_DAY',
});

export default transferFrequency;
